import PaymentMethod from "./paymentmethod";

export default PaymentMethod;
